module.exports = __webpack_public_path__ + "static/media/contactMailDark.6bef683e.svg";